import vee from "../../../../assets/images/productos/vee/VEE (1).png";
import qr from "../../../../assets/images/QR Fabian Llamazares.svg";
import Producto from "../../../../components/producto";

import pic1 from "../../../../assets/images/productos/vee/Mosaico - VEE1.jpeg";
import pic2 from "../../../../assets/images/productos/vee/Mosaico - VEE2.jpeg";

import { useTranslation } from "react-i18next";

function VEE() {
  const { t } = useTranslation();

  return (
    <Producto
      fotos={[pic1, pic2]}
      datosTabla1={[
        [t("tensionMaximaDeServicio"), "kV", "17,5 / 36"],
        [
          t("corrienteNominal"),
          "A",
          "630 / 800 / 1.250 / 2.000 / 2.500 / 3.150",
        ],
        [t("poderDeInterrupcion"), "kA", "20 / 25 / 31,5"],
        [t("corrienteBreveDuracion"), "kA (3sec)", "31,5"],
        [t("poderDeCierre"), "kA", "50 / 63 / 78"],
        [t("nivelDeAislacion"), "kV", "38 / 70"],
        [t("tensionDeImpulso"), "kV", "95 / 170"],
        [t("frecuenciaNominal"), "Hz", "50 / 60"],
        [t("tiempoDeCierreNominal"), "msec", "< 60"],
        [t("tiempoDeAperturaNominal"), "msec", "< 40"],
        [t("tiempoDeArcoNominal"), "msec", "5/15"],
      ]}
      datosTabla2={[
        [t("ancho"), "mm", "1.473"],
        [t("alto"), "mm", "3.200"],
        [t("profundidad"), "mm", "400"],
      ]}
      nombreProducto={"VEE"}
      fotoProducto={vee}
      descripcionProducto={t("vee.titulo_descripcion")}
      caracteristicas={[t("vee.bullet1"), t("vee.bullet2"), t("vee.bullet3")]}
      vendedor={{
        nombre: "Fabian Llamazares",
        telefono: "+54 9 11 5096-3680",
        mail: "fllamazares@ema.com.ar",
        qr: qr,
      }}
      pathPdf={"/assets/docs/2025%20-%20VEE.pdf"}
    />
  );
}

export default VEE;
